import { format, parse } from 'date-fns'

export const formatDateSimple = (
  apiDateString?: string | null,
  originalDateFormat: string = 'dd-MM-yyyy'
) => {
  if (!apiDateString) {
    return 'N/A'
  }
  try {
    const parsedDate = parse(apiDateString, originalDateFormat, new Date())
    const formatedDate = format(parsedDate, 'd MMM yyyy')
    return formatedDate || 'N/A'
  } catch (e) {
    return 'N/A'
  }
}

export const formatDateNice = (apiDateString?: string | null) => {
  return apiDateString && new Date(apiDateString).getDate()
    ? new Date(apiDateString).toLocaleDateString('gb', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })
    : 'N/A'
}
